// What each billing arrangement means, said as what the CLIENT experiences
// (PRD 40 §5.4).
//
// Shared by the intake panel, the set-up-books modal and the practice billing
// page. Extracted the moment a second screen needed it: two copies of "who
// pays" wording is how one of them ends up describing the wrong party.
import { BillingArrangement } from '../../types/firmApi';

export const ARRANGEMENT_COPY: Record<BillingArrangement, { label: string; note: string }> = {
  firm_billed_rebilled: {
    label: 'You are billed, and you bill them',
    note: 'You pay wholesale and invoice the client yourself.',
  },
  firm_billed: {
    label: 'You are billed, and absorb it',
    note: 'The client is never charged. You pay wholesale and bill them nothing for it.',
  },
  client_billed: {
    label: 'They are billed directly',
    note: 'The client pays Greenback themselves. Nothing appears on your subscription.',
  },
};

/**
 * The same three, as a badge fits (PRD 40 §5.4.2).
 *
 * Separate from `label` because a badge beside a client's name has no room
 * for "You are billed, and you bill them" — and because the long labels are
 * addressed to somebody CHOOSING an arrangement, where these describe one
 * already in force.
 */
export const ARRANGEMENT_BADGE: Record<BillingArrangement, string> = {
  firm_billed_rebilled: 'You pay, rebilled',
  firm_billed: 'You pay',
  client_billed: 'They pay',
};
/**
 * The button that PROPOSES each arrangement, in the chooser.
 *
 * Each one names its own target rather than repeating the client's name.
 * "Ask Acme Holdings" under all three options read identically, which made
 * the choice depend entirely on which paragraph the eye was last on — and
 * left the DOM with three indistinguishable buttons.
 */
export const ARRANGEMENT_REQUEST: Record<BillingArrangement, string> = {
  firm_billed_rebilled: 'Ask to bill them yourself',
  firm_billed: 'Ask to absorb it',
  client_billed: 'Ask them to pay directly',
};
